import {
  BriefcaseMedicalIcon,
  ClipboardListIcon,
  EyeIcon,
  HeartPulseIcon,
  LayersIcon,
  LockIcon,
  LucideIcon,
  RefreshCwIcon,
  ScissorsIcon,
  SearchIcon,
  ShieldCheckIcon,
  StethoscopeIcon,
  ZapIcon,
} from "lucide-react";

const icons: Record<string, LucideIcon> = {
  briefcase: BriefcaseMedicalIcon,
  clipboard: ClipboardListIcon,
  eye: EyeIcon,
  heart: HeartPulseIcon,
  layers: LayersIcon,
  lock: LockIcon,
  refresh: RefreshCwIcon,
  scissors: ScissorsIcon,
  search: SearchIcon,
  shield: ShieldCheckIcon,
  stethoscope: StethoscopeIcon,
  zap: ZapIcon,
};

export function getIcon(key: string): LucideIcon {
  return icons[key] ?? LayersIcon;
}
